export class FileUpload {
  public id: number;
  public tipo: string;
  public arquivo: string;
  public nomeArquivo: string;
  public dataInclusao: Date;

 // variaveis transient
 public idRespostaItem: number;
 public idPergunta: number;
 public idResposta: number;

}
